import { twMerge } from '@dynamika-shared/utils/twMerge';
import { FC } from 'react';

type InitialsProps = {
  initials: string;
  className?: string;
  classNameWrapper?: string;
};

export const Initials: FC<InitialsProps> = ({ initials, className, classNameWrapper }) => {
  return (
    <div className={classNameWrapper}>
      <span
        className={twMerge(
          'text-1424 font-semibold bg-brightGray !w-4 !h-4 flex items-center justify-center rounded-full me-1',
          className
        )}
      >
        {initials}
      </span>
    </div>
  );
};
